/* mtn-lists.js (2026-10-28)
   Quote list (+ Favourites opcional), guardados en localStorage. Config en
   window.MTN_LISTS (snippets/mtn-lists.liquid):
     favs: false  -> sin favoritos (EU y DE: solo quote list)
     t: {...}     -> textos (DE en aleman); los que falten caen en ingles
   Marcado que usa:
     [data-mtn-fav="handle"]   boton corazon (ficha y tarjetas)
     [data-mtn-open="quote"|"favs"]  abre el panel lateral
     [data-mtn-quote-add]      "Add to Quote List" dentro de [data-mtn-pdp]
     [data-mtn-count="quote"|"favs"] contadores de la cabecera
*/
(function () {
  'use strict';
  if (window.MTNLists) return;

  var C = window.MTN_LISTS || {};
  var VAT = Number(C.vat) || 1;
  var FAVS = C.favs !== false;
  var KEY_Q = 'mtnQuoteList';
  var KEY_F = 'mtnFavourites';
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  var T = {
    title: 'Your lists',
    quoteTitle: 'Quote list',
    tabQuote: 'Quote list',
    tabFavs: 'Favourites',
    close: 'Close',
    emptyQuote: 'Your quote list is empty.',
    emptyQuoteText: 'Use <em>Add to Quote List</em> on any product page to build a list, then send it to us in one request.',
    emptyFavs: 'No favourites yet.',
    emptyFavsText: 'Tap the heart on any product to save it here for later.',
    sku: 'SKU',
    inc: 'inc VAT',
    ex: 'ex VAT',
    onRequest: 'Price on request',
    from: 'From',
    out: 'Out of stock',
    qtyDown: 'Decrease quantity',
    qtyUp: 'Increase quantity',
    qty: 'Quantity',
    remove: 'Remove',
    total: 'Total',
    item: 'item',
    items: 'items',
    pricedOnly: ', priced items',
    send: 'Request a quote',
    note: 'Opens our quote form with this list already filled in. Add your details and send.',
    clear: 'Clear list',
    confirmClear: 'Remove all products from your quote list?',
    added: 'Added to Quote List',
    addFail: 'Could not add, try again',
    addCart: 'Add to cart',
    adding: 'Adding…',
    cartFail: 'Could not add',
    addQuote: 'Add to quote',
    addedQuote: 'Added to quote',
    options: 'Choose options',
    favSave: 'Save to favourites',
    /* texto que se escribe en el formulario de monday */
    fList: 'Quote list',
    fProduct: 'product',
    fProducts: 'products',
    fQty: 'Qty',
    fWebPrice: 'Web price',
    fEach: 'each',
    fOnRequest: 'on request',
    fComments: 'Comments'
  };
  /* != null: un texto vacio tambien cuenta (US quita "inc VAT" con inc: '') */
  if (C.t) for (var k in C.t) if (C.t[k] != null) T[k] = C.t[k];

  /* ---------- almacenamiento ---------- */
  function read(key) {
    try {
      var v = JSON.parse(localStorage.getItem(key));
      return Array.isArray(v) ? v : [];
    } catch (e) { return []; }
  }
  function write(key, val) {
    try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
  }
  var quote = read(KEY_Q);
  var favs = FAVS ? read(KEY_F).filter(function (h) { return typeof h === 'string'; }) : [];
  function saveQuote() { write(KEY_Q, quote); }
  function saveFavs() { write(KEY_F, favs); }

  /* Otra pestana cambia la lista: se recarga aqui tambien */
  window.addEventListener('storage', function (e) {
    if (e.key === KEY_Q) { quote = read(KEY_Q); refresh(); }
    if (FAVS && e.key === KEY_F) { favs = read(KEY_F); refresh(); }
  });

  /* ---------- utilidades ---------- */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function group(n, sep) { return n.replace(/\B(?=(\d{3})+(?!\d))/g, sep); }
  function money(cents) {
    var n = (Math.round(cents) / 100).toFixed(2).split('.');
    var fmt = C.moneyFormat || '£{{amount}}';
    return fmt
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, group(n[0], '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, group(n[0], ','))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, group(n[0], '.') + ',' + n[1])
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, group(n[0], "'") + '.' + n[1])
      .replace(/\{\{\s*amount\s*\}\}/, group(n[0], ',') + '.' + n[1]);
  }
  function incl(item) { return item.taxable === false ? item.price : Math.round(item.price * VAT); }
  function isQuoteOnly(price) { return price <= 1; } /* 0.01 = "contact for quote" en estas tiendas */
  function handleFromUrl(href) {
    var m = /\/products\/([^/?#]+)/.exec(href || '');
    return m ? decodeURIComponent(m[1]) : '';
  }
  function img(src, w) {
    if (!src) return '';
    src = src.replace(/^\/\//, 'https://');
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var cache = {};
  function getProduct(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(ROOT + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }

  /* ---------- favoritos ---------- */
  function isFav(h) { return favs.indexOf(h) > -1; }
  function toggleFav(h) {
    if (!h || !FAVS) return;
    if (isFav(h)) favs = favs.filter(function (x) { return x !== h; });
    else favs.unshift(h);
    saveFavs();
    refresh();
  }

  /* ---------- quote list ---------- */
  function addToQuote(handle, variantId, qty) {
    qty = Math.max(1, parseInt(qty, 10) || 1);
    return getProduct(handle).then(function (p) {
      if (!p) return false;
      var v = null;
      for (var i = 0; i < p.variants.length; i++) {
        if (String(p.variants[i].id) === String(variantId)) { v = p.variants[i]; break; }
      }
      v = v || p.variants[0];
      var existing = quote.filter(function (x) { return String(x.id) === String(v.id); })[0];
      if (existing) {
        existing.qty += qty;
      } else {
        quote.push({
          id: v.id,
          handle: p.handle,
          title: p.title,
          variant: p.variants.length > 1 ? v.title : '',
          sku: v.sku || '',
          price: v.price,
          taxable: v.taxable !== false,
          image: (v.featured_image && v.featured_image.src) || p.featured_image || '',
          url: p.url + (p.variants.length > 1 ? '?variant=' + v.id : ''),
          qty: qty
        });
      }
      saveQuote();
      refresh();
      return true;
    });
  }

  /* Texto para el formulario de monday */
  function quoteText(withUrls) {
    var lines = [T.fList + ' (' + quote.length + ' ' + (quote.length === 1 ? T.fProduct : T.fProducts) + '):'];
    quote.forEach(function (it, i) {
      lines.push((i + 1) + '. ' + it.title + (it.variant ? ' - ' + it.variant : ''));
      var d = [];
      if (it.sku) d.push(T.sku + ': ' + it.sku);
      d.push(T.fQty + ': ' + it.qty);
      d.push(T.fWebPrice + ': ' + (isQuoteOnly(it.price) ? T.fOnRequest : [money(incl(it)), T.inc, T.fEach].filter(Boolean).join(' ')));
      lines.push('   ' + d.join(' | '));
      if (withUrls) lines.push('   ' + location.origin + it.url);
    });
    lines.push('', T.fComments + ': ');
    return lines.join('\n');
  }
  function openQuoteForm() {
    if (!quote.length || !C.formUrl) return;
    var refs = quote.map(function (it) { return (it.sku || it.title) + ' x' + it.qty; }).join(', ');
    if (refs.length > 250) refs = refs.slice(0, 247) + '...';
    var text = quoteText(true);
    if (text.length > 2000) text = quoteText(false);
    if (text.length > 2000) text = text.slice(0, 1990) + '\n...';
    /* Si el formulario no tiene campo de productos (US), solo va el comentario. */
    var params = [];
    if (C.fieldProducts) params.push(encodeURIComponent(C.fieldProducts) + '=' + encodeURIComponent(refs));
    params.push(encodeURIComponent(C.fieldComments) + '=' + encodeURIComponent(text));
    var url = C.formUrl + (C.formUrl.indexOf('?') > -1 ? '&' : '?') + params.join('&');
    var w = 900, h = 700;
    var win = window.innerWidth >= 1000
      ? window.open(url, 'quote', 'width=' + w + ',height=' + h + ',left=' + Math.round((screen.width - w) / 2) + ',top=' + Math.round((screen.height - h) / 2) + ',scrollbars=yes,resizable=yes')
      : window.open(url, '_blank');
    if (!win) location.href = url;
  }

  /* ---------- panel lateral ---------- */
  var panel, lastFocus, tab = 'quote';

  var ICON_X = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var ICON_BIN = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4.5 6.5h15M9.5 6.5V4.5h5v2M6.5 6.5l1 13h9l1-13M10 10v6M14 10v6" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function buildPanel() {
    panel = document.createElement('div');
    panel.className = 'mtn-ld';
    panel.hidden = true;
    panel.innerHTML =
      '<div class="mtn-ld__veil" data-mtn-close></div>' +
      '<aside class="mtn-ld__panel" role="dialog" aria-modal="true" aria-labelledby="mtn-ld-title" tabindex="-1">' +
        '<header class="mtn-ld__head">' +
          '<h2 class="mtn-ld__title" id="mtn-ld-title">' + esc(FAVS ? T.title : T.quoteTitle) + '</h2>' +
          '<button type="button" class="mtn-ld__x" data-mtn-close aria-label="' + esc(T.close) + '">' + ICON_X + '</button>' +
        '</header>' +
        (FAVS
          ? '<div class="mtn-ld__tabs" role="tablist">' +
              '<button type="button" role="tab" class="mtn-ld__tab" data-mtn-tab="quote">' + esc(T.tabQuote) + ' <span data-mtn-count="quote" hidden></span></button>' +
              '<button type="button" role="tab" class="mtn-ld__tab" data-mtn-tab="favs">' + esc(T.tabFavs) + ' <span data-mtn-count="favs" hidden></span></button>' +
            '</div>'
          : '') +
        '<div class="mtn-ld__body" data-mtn-body></div>' +
        '<footer class="mtn-ld__foot" data-mtn-foot></footer>' +
      '</aside>';
    document.body.appendChild(panel);

    panel.addEventListener('click', onPanelClick);
    panel.addEventListener('input', onPanelInput);
    panel.addEventListener('change', onPanelInput);
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') trapFocus(e);
    });
  }

  function open(which) {
    if (!panel) buildPanel();
    tab = FAVS && which === 'favs' ? 'favs' : 'quote';
    lastFocus = document.activeElement;
    panel.hidden = false;
    document.documentElement.classList.add('mtn-ld-open');
    renderPanel();
    refreshCounts();
    requestAnimationFrame(function () {
      panel.classList.add('is-open');
      panel.querySelector('.mtn-ld__panel').focus();
    });
  }
  function close() {
    if (!panel || panel.hidden) return;
    panel.classList.remove('is-open');
    document.documentElement.classList.remove('mtn-ld-open');
    setTimeout(function () { panel.hidden = true; }, 220);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function trapFocus(e) {
    var f = panel.querySelectorAll('a[href], button:not([disabled]), input');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function renderPanel() {
    if (!panel || panel.hidden) return;
    panel.querySelectorAll('[data-mtn-tab]').forEach(function (b) {
      var on = b.getAttribute('data-mtn-tab') === tab;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    var body = panel.querySelector('[data-mtn-body]');
    var foot = panel.querySelector('[data-mtn-foot]');
    if (tab === 'quote') renderQuote(body, foot);
    else renderFavs(body, foot);
  }

  function priceHtml(price, taxable) {
    if (isQuoteOnly(price)) return '<span class="mtn-ld__price">' + esc(T.onRequest) + '</span>';
    var inc = taxable === false ? price : Math.round(price * VAT);
    return '<span class="mtn-ld__price">' + money(inc) + ' <small>' + esc(T.inc) + '</small></span>' +
      (VAT > 1 && taxable !== false ? '<span class="mtn-ld__ex">' + money(price) + ' ' + esc(T.ex) + '</span>' : '');
  }

  function renderQuote(body, foot) {
    if (!quote.length) {
      body.innerHTML = '<div class="mtn-ld__empty"><p><strong>' + esc(T.emptyQuote) + '</strong></p><p>' + T.emptyQuoteText + '</p></div>';
      foot.innerHTML = '';
      return;
    }
    body.innerHTML = '<ul class="mtn-ld__list">' + quote.map(function (it, i) {
      return '<li class="mtn-ld__item" data-i="' + i + '">' +
        '<a class="mtn-ld__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
        '<div class="mtn-ld__info">' +
          '<a class="mtn-ld__name" href="' + esc(it.url) + '">' + esc(it.title) + '</a>' +
          '<div class="mtn-ld__meta">' + (it.variant ? esc(it.variant) + ' &middot; ' : '') + (it.sku ? esc(T.sku) + ': ' + esc(it.sku) : '') + '</div>' +
          '<div class="mtn-ld__prices">' + priceHtml(it.price, it.taxable) + '</div>' +
          '<div class="mtn-ld__row">' +
            '<div class="mtn-ld__qty">' +
              '<button type="button" data-mtn-qty="-1" aria-label="' + esc(T.qtyDown) + '">&minus;</button>' +
              '<input type="number" min="1" inputmode="numeric" value="' + it.qty + '" data-mtn-field="qty" aria-label="' + esc(T.qty) + '">' +
              '<button type="button" data-mtn-qty="1" aria-label="' + esc(T.qtyUp) + '">+</button>' +
            '</div>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="mtn-ld__rm" data-mtn-rm aria-label="' + esc(T.remove) + ': ' + esc(it.title) + '">' + ICON_BIN + '</button>' +
      '</li>';
    }).join('') + '</ul>';
    foot.innerHTML =
      '<div class="mtn-ld__total" data-mtn-total></div>' +
      '<button type="button" class="mtn-ld__cta" data-mtn-send>' + esc(T.send) + '</button>' +
      '<p class="mtn-ld__note">' + esc(T.note) + '</p>' +
      '<button type="button" class="mtn-ld__clear" data-mtn-clear>' + esc(T.clear) + '</button>';
    renderTotal();
  }

  function renderTotal() {
    var el = panel && panel.querySelector('[data-mtn-total]');
    if (!el) return;
    var units = 0, inc = 0, ex = 0, priced = true;
    quote.forEach(function (it) {
      units += it.qty;
      if (isQuoteOnly(it.price)) { priced = false; return; }
      /* IVA sobre el total de la linea, como Shopify (3 x 11.47 + IVA = 41.29, no 3 x 13.76) */
      inc += it.taxable === false ? it.price * it.qty : Math.round(it.price * it.qty * VAT);
      ex += it.price * it.qty;
    });
    el.innerHTML = '<span>' + esc(T.total) + ' ' + units + ' ' + esc(units === 1 ? T.item : T.items) + '</span>' +
      '<span class="mtn-ld__sum"><strong>' + money(inc) + '</strong> <small>' + esc(T.inc) + (priced ? '' : esc(T.pricedOnly)) + '</small>' +
      (VAT > 1 ? '<em>' + money(ex) + ' ' + esc(T.ex) + '</em>' : '') + '</span>';
  }

  function renderFavs(body, foot) {
    foot.innerHTML = '';
    if (!favs.length) {
      body.innerHTML = '<div class="mtn-ld__empty"><p><strong>' + esc(T.emptyFavs) + '</strong></p><p>' + esc(T.emptyFavsText) + '</p></div>';
      return;
    }
    body.innerHTML = '<ul class="mtn-ld__list">' + favs.map(function (h) {
      return '<li class="mtn-ld__item is-loading" data-handle="' + esc(h) + '"><span class="mtn-ld__img"></span><div class="mtn-ld__info"><span class="mtn-ld__skel"></span><span class="mtn-ld__skel mtn-ld__skel--s"></span></div></li>';
    }).join('') + '</ul>';
    favs.forEach(function (h) {
      getProduct(h).then(function (p) {
        var li = body.querySelector('[data-handle="' + (window.CSS && CSS.escape ? CSS.escape(h) : h) + '"]');
        if (!li) return;
        if (!p) { li.remove(); favs = favs.filter(function (x) { return x !== h; }); saveFavs(); refreshCounts(); return; }
        var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
        var single = p.variants.length === 1;
        var quoteOnly = isQuoteOnly(v.price);
        var actions = '';
        if (single && v.available && !quoteOnly) actions += '<button type="button" class="mtn-ld__btn mtn-ld__btn--ink" data-mtn-cart="' + v.id + '">' + esc(T.addCart) + '</button>';
        if (single) actions += '<button type="button" class="mtn-ld__btn" data-mtn-fav-quote="' + v.id + '">' + esc(T.addQuote) + '</button>';
        else actions += '<a class="mtn-ld__btn mtn-ld__btn--ink" href="' + esc(p.url) + '">' + esc(T.options) + '</a>';
        li.classList.remove('is-loading');
        li.innerHTML =
          '<a class="mtn-ld__img" href="' + esc(p.url) + '">' + (p.featured_image ? '<img src="' + esc(img(p.featured_image, 160)) + '" alt="" width="72" height="72" loading="lazy">' : '') + '</a>' +
          '<div class="mtn-ld__info">' +
            '<a class="mtn-ld__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
            '<div class="mtn-ld__meta">' + esc(p.vendor || '') + (single && v.sku ? ' &middot; ' + esc(T.sku) + ': ' + esc(v.sku) : '') + '</div>' +
            '<div class="mtn-ld__prices">' + (single ? priceHtml(v.price, v.taxable) : (quoteOnly ? priceHtml(1) : '<span class="mtn-ld__price"><small>' + esc(T.from) + '</small> ' + money(v.taxable === false ? p.price_min : Math.round(p.price_min * VAT)) + ' <small>' + esc(T.inc) + '</small></span>')) +
              (!p.available ? '<span class="mtn-ld__out">' + esc(T.out) + '</span>' : '') + '</div>' +
            '<div class="mtn-ld__row">' + actions + '</div>' +
          '</div>' +
          '<button type="button" class="mtn-ld__rm" data-mtn-fav-rm aria-label="' + esc(T.remove) + ': ' + esc(p.title) + '">' + ICON_BIN + '</button>';
      });
    });
  }

  function onPanelClick(e) {
    var t = e.target;
    var b;
    if (t.closest('[data-mtn-close]')) { close(); return; }
    if ((b = t.closest('[data-mtn-tab]'))) { tab = b.getAttribute('data-mtn-tab'); renderPanel(); return; }
    if (t.closest('[data-mtn-send]')) { openQuoteForm(); return; }
    if (t.closest('[data-mtn-clear]')) {
      if (window.confirm(T.confirmClear)) { quote = []; saveQuote(); refresh(); }
      return;
    }
    var li = t.closest('.mtn-ld__item');
    if (!li) return;
    if (tab === 'quote') {
      var i = +li.getAttribute('data-i');
      if (t.closest('[data-mtn-rm]')) { quote.splice(i, 1); saveQuote(); refresh(); return; }
      if ((b = t.closest('[data-mtn-qty]'))) {
        quote[i].qty = Math.max(1, quote[i].qty + Number(b.getAttribute('data-mtn-qty')));
        li.querySelector('[data-mtn-field="qty"]').value = quote[i].qty;
        saveQuote(); renderTotal(); refreshCounts();
      }
      return;
    }
    var h = li.getAttribute('data-handle');
    if (t.closest('[data-mtn-fav-rm]')) { toggleFav(h); return; }
    if ((b = t.closest('[data-mtn-fav-quote]'))) {
      b.disabled = true;
      addToQuote(h, b.getAttribute('data-mtn-fav-quote'), 1).then(function () {
        b.textContent = T.addedQuote;
      });
      return;
    }
    if ((b = t.closest('[data-mtn-cart]'))) {
      b.disabled = true;
      b.textContent = T.adding;
      fetch(ROOT + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(b.getAttribute('data-mtn-cart')), quantity: 1 }] })
      }).then(function (r) {
        if (r.ok) { location.href = ROOT + 'cart'; return; }
        b.disabled = false; b.textContent = T.cartFail;
      });
    }
  }

  function onPanelInput(e) {
    var f = e.target.getAttribute('data-mtn-field');
    var li = e.target.closest('.mtn-ld__item');
    if (!f || !li || tab !== 'quote') return;
    var it = quote[+li.getAttribute('data-i')];
    if (!it) return;
    if (f !== 'qty') return;
    var n = parseInt(e.target.value, 10);
    if (n > 0) it.qty = n;
    else if (e.type === 'change') { it.qty = 1; e.target.value = 1; }
    saveQuote(); renderTotal(); refreshCounts();
  }

  /* ---------- cabecera, corazones y tarjetas ---------- */
  function refreshCounts() {
    var units = quote.reduce(function (s, it) { return s + it.qty; }, 0);
    document.querySelectorAll('[data-mtn-count]').forEach(function (el) {
      var n = el.getAttribute('data-mtn-count') === 'quote' ? units : favs.length;
      el.textContent = n > 99 ? '99+' : n;
      el.hidden = n === 0;
    });
  }
  function refreshHearts() {
    if (!FAVS) return;
    document.querySelectorAll('[data-mtn-fav]').forEach(function (b) {
      var on = isFav(b.getAttribute('data-mtn-fav'));
      b.classList.toggle('is-on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  function refresh() { refreshCounts(); refreshHearts(); renderPanel(); }

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.3l-1.2-1.1C6.2 15.1 3.2 12.4 3.2 9a4.6 4.6 0 0 1 4.7-4.7c1.6 0 3.1.7 4.1 1.9 1-1.2 2.5-1.9 4.1-1.9A4.6 4.6 0 0 1 20.8 9c0 3.4-3 6.1-7.6 10.2L12 20.3z"/></svg>';
  /* .cpf-card = rejilla de coleccion (collection-page-filters), .at-v2-card =
     carruseles de la home y recomendaciones, .gr-card-* = secciones antiguas */
  var CARDS = '.cpf-card, .at-v2-card, .gr-card-rich-product, .gr-card-product';
  function decorateCards(root) {
    (root || document).querySelectorAll(CARDS).forEach(function (card) {
      if (card.querySelector('.mtn-fav--card')) return;
      var link = card.matches('a[href*="/products/"]') ? card : card.querySelector('a[href*="/products/"]');
      var h = link && handleFromUrl(link.getAttribute('href'));
      if (!h) return;
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'mtn-fav mtn-fav--card';
      b.setAttribute('data-mtn-fav', h);
      b.setAttribute('aria-label', T.favSave);
      b.innerHTML = HEART;
      card.classList.add('mtn-has-fav');
      /* Abajo a la izquierda de la foto, como Amazon: arriba quedan las etiquetas
         (Top rated, SAVE...). Sin contenedor de foto conocido, en la tarjeta. */
      var slot = card.querySelector('.cpf-card__img, .at-v2-card__art') || card;
      slot.classList.add('mtn-fav-slot');
      slot.appendChild(b);
    });
    refreshHearts();
  }
  if (FAVS) {
    /* Las tarjetas de coleccion las pinta el JS de filtros despues de cargar y al
       filtrar. setTimeout y no requestAnimationFrame: rAF no corre en pestanas
       ocultas. */
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; decorateCards(); }, 60);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  /* ---------- clics globales ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-mtn-fav]');
    if (b && FAVS && !b.closest('.mtn-ld')) {
      e.preventDefault();
      e.stopPropagation();
      toggleFav(b.getAttribute('data-mtn-fav'));
      return;
    }
    if ((b = e.target.closest('[data-mtn-open]'))) {
      e.preventDefault();
      open(b.getAttribute('data-mtn-open'));
      return;
    }
    if ((b = e.target.closest('[data-mtn-quote-add]'))) {
      e.preventDefault();
      var box = b.closest('[data-mtn-pdp]');
      if (!box || b.disabled) return;
      var formId = box.getAttribute('data-form');
      var form = formId && document.getElementById(formId);
      var idInput = form && form.querySelector('[name="id"]');
      var variantId = (idInput && idInput.value) || new URLSearchParams(location.search).get('variant') || box.getAttribute('data-variant');
      var qtyInput = formId && document.querySelector('input[name="quantity"][form="' + formId + '"]');
      var label = b.querySelector('[data-mtn-quote-label]') || b;
      var text = label.textContent;
      b.disabled = true;
      addToQuote(box.getAttribute('data-handle'), variantId, qtyInput ? qtyInput.value : 1).then(function (ok) {
        b.disabled = false;
        label.textContent = ok ? T.added : T.addFail;
        setTimeout(function () { label.textContent = text; }, 2500);
        if (ok) open('quote');
      });
    }
  }, true);

  function init() { refreshCounts(); if (FAVS) decorateCards(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  window.MTNLists = { open: open, close: close, addToQuote: addToQuote, toggleFav: toggleFav };
})();
